<div class="flex width-100 height-100 bg-white">
  @if (!ehMobile) {
    <img src="./assets/img-login.png" class="img-background-desktop" alt=""/>
  }


  <div [ngClass]="ehMobile ? 'mobile' : ''" class="flex-direction-column center-center area-acao-login gap-25" [style]="!isProd && ehMobile ? 'height: calc(100vh - 16px)' : ''">
    <div class="flex-direction-column gap-15 align-center width-100 align-inputs-login">
      <div class="flex-direction-row gap-15 align-center width-100 align-inputs-login">
        <div class="flex-direction-column gap-15 align-center width-100 align-inputs-login">
          <div class="flex-direction-row gap-15 align-center width-100 align-inputs-login" style="align-items: center;">
            <span class="weight-700 width-100 title-text-apresentacao" style="font-size: 35px;">{{ getApresentacao() }}</span>
            @if(!ehMobile){
              <img class="logo_clari" src="./assets/clari-talk-logo.png" alt="Clari Talk" />
            }
            @else {
              <img src="./assets/logo.png" alt="" class="logo_clari_mobile">
            }
          </div>
          <span class="width-100 font-14 text-sub-title" style="color: rgb(105 105 105); font-weight: 200;">
            @if (exibicao.codigoRedefiniciao){
              Enviamos para seu e-mail um código de verificação de 6 digitos
            } @else if (exibicao.trocaSenha){
              Digite sua nova senha.
            }
            @else {
              Para começar, faça login na sua conta
            }
          </span>
        </div>
      </div>

      <div class="flex-direction-column gap-10 align-center width-100">
        @if (exibicao.email){
          <app-form-field
            class="width-100"
            classe="login"
            heightFormField="50px"
            type="email"
            autocomplete="username"
            placeholder="Email"
            iconColor="#6213B7"
            iconPrefix="account_circle"
            borderColor="var(--primary)"
            backgroundColor="rgba(221, 188, 255, 0.1)"
            colorLabel="var(--primary)"
            [value]="login.login"
            (changeValue)="selecionarEmail($event)">
          </app-form-field>
        }
        @if (exibicao.grupo) {
          <app-select-one class="width-100" [classe]="'login'" heightFormField="50px" placeholder="Selecione o Grupo" iconPrefix="holiday_village" iconColor="#6213B7" borderColor="var(--primary)"
              [listaInput]="grupos" [itemSelecionado]="login.grupo" backgroundColor="rgba(221, 188, 255, 0.1)" campo="nome" (selecionarItem)="selecionarGrupo($event)"></app-select-one>
        }
        @if (exibicao.senha) {
          <div class="flex-direction-column gap-10 align-center width-100">
            <app-form-field
              #senhaInput
              class="width-100"
              classe="login"
              heightFormField="50px"
              type="password"
              autocomplete="current-password"
              placeholder="Senha"
              iconColor="#6213B7"
              iconPrefix="vpn_key"
              [isSenha]="true"
              borderColor="var(--primary)"
              backgroundColor="rgba(221, 188, 255, 0.1)"
              colorLabel="var(--primary)"
              [value]="login.senha"
              (changeValue)="login.senha = $event">
            </app-form-field>
            <div class="flex-direction-row justify-end width-100">
              <span class="cursor-pointer font-14 weight-700" style="text-decoration: underline; z-index: 0;" role="button" tabindex="0" (click)="redefinirSenha()" (keydown.enter)="redefinirSenha()">Esqueci minha senha?</span>
            </div>
          </div>
        }
        @if (exibicao.codigoRedefiniciao){
          <app-codigo-redefinicao (codigoRetorno)="buscarCodigoRedefiniciao($event)"></app-codigo-redefinicao>
        }
        @if (exibicao.trocaSenha){
          <div class="flex-direction-column gap-10 align-center width-100">
            <app-troca-senha style="width: 100%;" (envioSenha)="alterarSenha($event)"></app-troca-senha>
          </div>
        }
        <div class="flex-direction-column gap-10 width-100">
          @if (!exibicao.trocaSenha) {
            <button mat-raised-button class="button-login color-text-primary width-100" style="background-color: #6212B6;" (click)="logar()">
              {{ exibicao.codigoRedefiniciao ? 'Verificar' : 'Login' }}
            </button>
          }
          @if (exibicao.codigoRedefiniciao){
            <button mat-raised-button class="width-100 font-22 weight-700" style="height: 65px; border: 1px solid var(--primary); color: var(--primary);" (click)="voltar('redefinicaoSenha')">
              Voltar
            </button>
          }
        </div>
      </div>
    </div>

  </div>


</div>
